<template>
  <div class="medical-conditions rounded-lg pa-2">
    <strong class="medical-conditions__text">
      Note:
    </strong>
    <span class="medical-conditions__text ml-1">
      If you have any pre-existing medical conditions please
    </span>
    <a
      :href="existingMedicalConditionsLink"
      target="_blank"
      rel="nofollow"
      class="medical-conditions__link text-decoration-underline"
    >
      <span>click here</span>
    </a>
    <qz-tooltip left>
      <template #tooltip-body>
        A pre-existing medical condition is an illness or medical condition
        that you or someone in your party has before travelling.
      </template>
    </qz-tooltip>
  </div>
</template>

<script>
import {
  PARTNERS,
  MEDICAL_LINK,
} from '@/constants/common';
import QzTooltip from '@/components/QzTooltip/QzTooltip';

export default {
  name: 'medical-conditions-info',
  components: {
    QzTooltip,
  },
  inject: ['config'],
  computed: {
    existingMedicalConditionsLink () {
      return PARTNERS.CompareNI.includes(this.config.partner) ? MEDICAL_LINK.CNI : MEDICAL_LINK.QZ;
    },
  },
};
</script>

<style lang="scss" scoped>
.medical-conditions {
  border: 1px solid $clr-black;
  background: linear-gradient(180deg, $clr-seopa-light-yellow, $clr-seopa-yellow);

  &__link,
  &__text {
    vertical-align: middle;
  }

  &__link {
    margin-right: 8px;
    color: inherit;
  }
}
</style>
